(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const keyFor = (message) => {
      let hash = 0;

      for (let index = 0; index < message.length; index += 1) {
        hash = ((hash << 5) - hash + message.charCodeAt(index)) | 0;
      }

      return `gc-announcement-${Math.abs(hash).toString(36)}`;
    };

    const readDismissed = (key) => {
      try {
        return window.localStorage.getItem(key) === 'dismissed';
      } catch (error) {
        return false;
      }
    };

    const writeDismissed = (key) => {
      try {
        window.localStorage.setItem(key, 'dismissed');
      } catch (error) {
        return;
      }
    };

    const bindBar = (bar) => {
      if (bar.dataset.announcementBound === 'true') {
        return;
      }

      bar.dataset.announcementBound = 'true';

      const message = bar.dataset.message || '';
      const key = keyFor(message);
      const closeButton = bar.querySelector('[data-announcement-close]');

      if (readDismissed(key)) {
        bar.hidden = true;
        return;
      }

      closeButton?.addEventListener('click', () => {
        writeDismissed(key);
        bar.hidden = true;
      });
    };

    const bindBars = (scope) => {
      const root = scope instanceof Element ? scope : document;
      root.querySelectorAll('[data-announcement-bar]').forEach(bindBar);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => bindBars(document), { once: true });
    } else {
      bindBars(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      bindBars(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["article"]) return;
  try {
    
  (() => {
    const copyText = async (text) => {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return;
      }

      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.top = '-100vh';
      document.body.appendChild(textarea);
      textarea.select();
      const copied = document.execCommand('copy');
      textarea.remove();

      if (!copied) {
        throw new Error('Copy failed');
      }
    };

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-article-share]');

      if (!button) {
        return;
      }

      const url = button.dataset.shareUrl;
      const title = button.dataset.shareTitle || document.title;
      const panel = button.closest('[data-article-share-panel]');
      const status = panel ? panel.querySelector('[data-article-share-status]') : null;

      try {
        if (navigator.share) {
          await navigator.share({ title, url });

          if (status) {
            status.textContent = button.dataset.sharedLabel || 'Beitrag geteilt.';
          }

          return;
        }

        await copyText(url);

        if (status) {
          status.textContent = button.dataset.copiedLabel || 'Link kopiert.';
        }
      } catch (error) {
        if (error.name === 'AbortError') {
          return;
        }

        try {
          await copyText(url);

          if (status) {
            status.textContent = button.dataset.copiedLabel || 'Link kopiert.';
          }
        } catch (copyError) {
          if (status) {
            status.textContent = url;
          }
        }
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    const createListboxPopoverController = (button, list) => {
      const supportsPopover = typeof list.showPopover === 'function' && typeof list.hidePopover === 'function';
      const gap = 8;
      const viewportPadding = 12;
      const maxListHeight = 320;
      const minListHeight = 96;
      let isPositioningBound = false;

      if (supportsPopover) {
        list.setAttribute('popover', 'manual');
      }

      const position = () => {
        if (!supportsPopover || list.hidden) {
          return;
        }

        const rect = button.getBoundingClientRect();
        const viewportWidth = document.documentElement.clientWidth || window.innerWidth;
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
        const maxWidth = Math.max(1, viewportWidth - viewportPadding * 2);
        const width = Math.min(rect.width, maxWidth);
        const left = Math.min(Math.max(rect.left, viewportPadding), viewportWidth - viewportPadding - width);
        const availableBelow = viewportHeight - rect.bottom - gap - viewportPadding;
        const availableAbove = rect.top - gap - viewportPadding;
        const naturalHeight = Math.min(list.scrollHeight || maxListHeight, maxListHeight);
        const openAbove = availableBelow < naturalHeight && availableAbove > availableBelow;
        const availableSpace = Math.max(minListHeight, openAbove ? availableAbove : availableBelow);
        const listHeight = Math.min(naturalHeight, availableSpace, maxListHeight);
        const top = openAbove
          ? Math.max(viewportPadding, rect.top - listHeight - gap)
          : Math.min(rect.bottom + gap, viewportHeight - viewportPadding - listHeight);

        list.style.left = `${Math.round(left)}px`;
        list.style.top = `${Math.round(Math.max(viewportPadding, top))}px`;
        list.style.width = `${Math.round(width)}px`;
        list.style.maxHeight = `${Math.round(listHeight)}px`;
      };

      const bindPositioning = () => {
        if (isPositioningBound) {
          return;
        }

        isPositioningBound = true;
        window.addEventListener('scroll', position, true);
        window.addEventListener('resize', position);
      };

      const unbindPositioning = () => {
        if (!isPositioningBound) {
          return;
        }

        isPositioningBound = false;
        window.removeEventListener('scroll', position, true);
        window.removeEventListener('resize', position);
      };

      return {
        position,
        open() {
          list.hidden = false;

          if (!supportsPopover) {
            return;
          }

          position();

          if (!list.matches(':popover-open')) {
            list.showPopover();
          }

          position();
          bindPositioning();
        },
        close() {
          unbindPositioning();

          if (supportsPopover && list.matches(':popover-open')) {
            list.hidePopover();
          }

          list.hidden = true;
        },
      };
    };

    const customSelects = document.querySelectorAll('[data-focus-custom-select]');

    customSelects.forEach((root) => {
      if (root.dataset.focusCustomSelectReady === 'true') {
        return;
      }

      const select = document.getElementById(root.dataset.focusCustomSelect);
      const button = root.querySelector('[data-focus-custom-select-button]');
      const valueNode = root.querySelector('[data-focus-custom-select-value]');
      const list = root.querySelector('[data-focus-custom-select-list]');

      if (!select || !button || !valueNode || !list) {
        return;
      }

      const form = select.form;
      const options = Array.from(select.options);

      if (options.length === 0) {
        return;
      }

      root.dataset.focusCustomSelectReady = 'true';
      root.hidden = false;
      select.classList.add('is-focus-custom-select-native');
      select.setAttribute('aria-hidden', 'true');
      select.tabIndex = -1;

      let activeIndex = Math.max(0, select.selectedIndex);
      let typeahead = '';
      let typeaheadTimer = 0;
      let pressedOptionIndex = null;

      const optionNodes = options.map((option, index) => {
        const item = document.createElement('li');
        item.id = `${list.id}-option-${index}`;
        item.className = 'focus-collection-page__custom-select-option';
        item.setAttribute('role', 'option');
        item.dataset.value = option.value;
        item.textContent = option.textContent.trim();

        if (option.disabled) {
          item.setAttribute('aria-disabled', 'true');
        }

        list.appendChild(item);
        return item;
      });

      const getSelectedIndex = () => Math.max(0, options.findIndex((option) => option.value === select.value));
      const listboxPopover = createListboxPopoverController(button, list);

      const setActive = (index, shouldScroll = false) => {
        activeIndex = (index + optionNodes.length) % optionNodes.length;

        optionNodes.forEach((node, nodeIndex) => {
          node.classList.toggle('is-active', nodeIndex === activeIndex);
        });

        list.setAttribute('aria-activedescendant', optionNodes[activeIndex].id);

        if (shouldScroll) {
          optionNodes[activeIndex].scrollIntoView({ block: 'nearest' });
        }
      };

      const syncSelection = () => {
        const selectedIndex = getSelectedIndex();
        const selectedOption = options[selectedIndex];

        valueNode.textContent = selectedOption.textContent.trim();

        optionNodes.forEach((node, nodeIndex) => {
          node.setAttribute('aria-selected', String(nodeIndex === selectedIndex));
        });

        setActive(selectedIndex);
      };

      const openList = () => {
        root.classList.add('is-open');
        form?.classList.add('is-custom-select-open');
        button.setAttribute('aria-expanded', 'true');
        listboxPopover.open();
        setActive(getSelectedIndex(), true);
        listboxPopover.position();
        window.requestAnimationFrame(() => list.focus({ preventScroll: true }));
      };

      const closeList = (focusButton = true) => {
        root.classList.remove('is-open');
        form?.classList.remove('is-custom-select-open');
        button.setAttribute('aria-expanded', 'false');
        listboxPopover.close();
        pressedOptionIndex = null;

        if (focusButton) {
          button.focus({ preventScroll: true });
        }
      };

      const chooseOption = (index) => {
        const option = options[index];

        if (!option || option.disabled) {
          return;
        }

        if (select.value !== option.value) {
          select.value = option.value;
          syncSelection();
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }

        closeList();
      };

      const matchTypeahead = (key) => {
        typeahead += key.toLocaleLowerCase('de-DE');
        window.clearTimeout(typeaheadTimer);
        typeaheadTimer = window.setTimeout(() => {
          typeahead = '';
        }, 700);

        const startIndex = activeIndex + 1;
        const orderedOptions = options.slice(startIndex).concat(options.slice(0, startIndex));
        const match = orderedOptions.find((option) => option.textContent.trim().toLocaleLowerCase('de-DE').startsWith(typeahead));

        if (!match) {
          return;
        }

        setActive(options.indexOf(match), true);
      };

      const isPrintableKey = (event) => event.key.length === 1 && !event.altKey && !event.ctrlKey && !event.metaKey;

      const handlePrintableKey = (event) => {
        if (!isPrintableKey(event)) {
          return false;
        }

        event.preventDefault();
        matchTypeahead(event.key);
        return true;
      };

      const handleNavigationKey = (event) => {
        switch (event.key) {
          case 'ArrowDown':
            event.preventDefault();
            setActive(activeIndex + 1, true);
            return true;
          case 'ArrowUp':
            event.preventDefault();
            setActive(activeIndex - 1, true);
            return true;
          case 'Home':
            event.preventDefault();
            setActive(0, true);
            return true;
          case 'End':
            event.preventDefault();
            setActive(optionNodes.length - 1, true);
            return true;
          default:
            return false;
        }
      };

      button.addEventListener('click', () => {
        if (root.classList.contains('is-open')) {
          closeList();
        } else {
          openList();
        }
      });

      button.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          openList();
          return;
        }

        if (['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
          event.preventDefault();
          openList();

          if (event.key === 'ArrowDown') {
            setActive(activeIndex + 1, true);
          } else if (event.key === 'ArrowUp') {
            setActive(activeIndex - 1, true);
          } else if (event.key === 'Home') {
            setActive(0, true);
          } else {
            setActive(optionNodes.length - 1, true);
          }

          return;
        }

        if (isPrintableKey(event)) {
          event.preventDefault();
          openList();
          matchTypeahead(event.key);
        }
      });

      list.addEventListener('keydown', (event) => {
        if (handleNavigationKey(event) || handlePrintableKey(event)) {
          return;
        }

        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          chooseOption(activeIndex);
        } else if (event.key === 'Escape') {
          event.preventDefault();
          closeList();
        } else if (event.key === 'Tab') {
          closeList(false);
        }
      });

      optionNodes.forEach((node, index) => {
        node.addEventListener('pointerenter', () => setActive(index));
        node.addEventListener('pointerdown', (event) => {
          pressedOptionIndex = index;
          setActive(index);

          if (event.pointerType !== 'touch') {
            event.preventDefault();
          }
        });
        node.addEventListener('pointerup', () => {
          if (pressedOptionIndex === index) {
            chooseOption(index);
          }
        });
        node.addEventListener('pointercancel', () => {
          pressedOptionIndex = null;
        });
        node.addEventListener('click', () => chooseOption(index));
      });

      document.addEventListener('pointerdown', (event) => {
        if (root.classList.contains('is-open') && !root.contains(event.target)) {
          closeList(false);
        }
      });

      root.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (root.classList.contains('is-open') && pressedOptionIndex === null && !root.contains(document.activeElement)) {
            closeList(false);
          }
        });
      });

      select.addEventListener('change', syncSelection);
      syncSelection();
    });
  })();

  (() => {
    if (!window.fetch || !window.FormData) {
      return;
    }

    const restoreButton = (button, label, text) => {
      if (label) {
        label.textContent = text;
      } else {
        button.textContent = text;
      }

      button.classList.remove('is-added', 'is-error');
      button.disabled = false;
      button.removeAttribute('aria-busy');
    };

    const updateHeaderCartCount = (count) => {
      document.querySelectorAll('.site-header__cart').forEach((cartLink) => {
        let badge = cartLink.querySelector('.site-header__cart-count');

        if (count > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'site-header__cart-count';
            cartLink.prepend(badge);
          }

          badge.textContent = String(count);
        } else if (badge) {
          badge.remove();
        }
      });
    };

    document.addEventListener('click', async (event) => {
      const button = event.target.closest('[data-collection-quick-add-button]');

      if (!button) {
        return;
      }

      const form = button.closest('[data-collection-quick-add]');

      if (!form || button.disabled) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      const label = button.querySelector('[data-collection-quick-add-label]');
      const originalText = button.dataset.originalLabel || (label ? label.textContent : button.textContent);
      button.dataset.originalLabel = originalText;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form),
        });

        if (!response.ok) {
          throw new Error('cart-add-failed');
        }

        const cartResponse = await fetch('/cart.js', {
          headers: { Accept: 'application/json' },
        });

        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          updateHeaderCartCount(Number(cart.item_count || 0));
        }

        if (label) {
          label.textContent = '✓ Hinzugefügt';
        } else {
          button.textContent = '✓ Hinzugefügt';
        }

        button.classList.add('is-added');
        window.setTimeout(() => restoreButton(button, label, originalText), 1600);
      } catch (error) {
        if (label) {
          label.textContent = 'Erneut versuchen';
        } else {
          button.textContent = 'Erneut versuchen';
        }

        button.classList.add('is-error');
        window.setTimeout(() => restoreButton(button, label, originalText), 1800);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["focus-product-offer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const selector = '.focus-offer';

    const getVariantSelect = (section) => {
      const select =
        section.querySelector('[data-focus-offer-variant-select]') ||
        section.querySelector('.focus-offer__field--variant select[name="id"]');

      if (select) {
        select.setAttribute('data-focus-offer-variant-select', '');
      }

      return select;
    };

    const updateVariantState = (section) => {
      const variantSelect = getVariantSelect(section);
      if (!variantSelect) {
        return;
      }

      const option = variantSelect.selectedOptions[0];
      if (!option) {
        return;
      }

      const price = section.querySelector('[data-focus-offer-price]');
      const compare = section.querySelector('[data-focus-offer-compare]');
      const save = section.querySelector('[data-focus-offer-save]');
      const buttonPrice = section.querySelector('[data-focus-offer-button-price]');
      const stock = section.querySelector('[data-focus-offer-stock]');
      const submit = section.querySelector('[data-focus-offer-submit]');

      if (price) {
        price.textContent = option.dataset.price || '';
      }

      if (buttonPrice) {
        buttonPrice.textContent = option.dataset.price || '';
      }

      const rawPrice = Number(option.dataset.rawPrice || 0);
      const rawCompareAt = Number(option.dataset.rawCompareAt || 0);
      const hasSavings = rawCompareAt > rawPrice;

      if (compare) {
        compare.textContent = hasSavings ? option.dataset.compareAt || '' : '';
        compare.hidden = !hasSavings;
      }

      if (save) {
        if (hasSavings) {
          const savingsPercent = Math.round(((rawCompareAt - rawPrice) * 100) / rawCompareAt);
          save.textContent = `-${savingsPercent}%`;
          save.hidden = false;
        } else {
          save.textContent = '';
          save.hidden = true;
        }
      }

      const available = option.dataset.available === 'true';

      if (submit) {
        submit.disabled = !available;
      }

      if (stock) {
        stock.textContent = available ? stock.dataset.stockAvailable || '' : stock.dataset.stockUnavailable || '';
        stock.classList.toggle('is-unavailable', !available);
      }
    };

    const bindQuantity = (section) => {
      if (section.dataset.focusOfferBound === 'true') {
        return;
      }

      section.dataset.focusOfferBound = 'true';

      const input = section.querySelector('[data-focus-offer-qty-input]');
      const buttons = section.querySelectorAll('[data-focus-offer-qty-change]');
      const variantSelect = getVariantSelect(section);

      buttons.forEach((button) => {
        button.addEventListener('click', () => {
          if (!input) {
            return;
          }

          const delta = Number(button.dataset.focusOfferQtyChange || 0);
          const nextValue = Math.max(1, Number(input.value || 1) + delta);
          input.value = `${nextValue}`;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });

      if (input) {
        input.addEventListener('change', () => {
          if (Number(input.value || 0) < 1) {
            input.value = '1';
          }
        });
      }

      if (variantSelect) {
        variantSelect.addEventListener('change', () => {
          updateVariantState(section);
        });
      }

      updateVariantState(section);
    };

    const bindSections = (scope) => {
      const root = scope instanceof Element ? scope : document;
      root.querySelectorAll(selector).forEach((section) => bindQuantity(section));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => bindSections(document), { once: true });
    } else {
      bindSections(document);
    }

    document.addEventListener('shopify:section:load', (event) => {
      bindSections(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', class PredictiveSearch extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[type="search"]');
        this.results = this.querySelector('[role="listbox"]');
        this.toggle = this.querySelector('button[aria-controls]');
        this.abortController = null;
        this.activeIndex = -1;
        this.debounceTimer = null;

        if (!this.form || !this.input || !this.results) return;

        this.input.addEventListener('input', () => this.queueSearch());
        this.input.addEventListener('keydown', (event) => this.onKeydown(event));
        this.toggle?.addEventListener('click', () => this.toggleMobileSearch());
        document.addEventListener('pointerdown', (event) => this.closeOnOutside(event));
        document.addEventListener('focusin', (event) => this.closeOnOutside(event));
      }

      queueSearch() {
        window.clearTimeout(this.debounceTimer);
        this.debounceTimer = window.setTimeout(() => this.search(), 200);
      }

      search() {
        const query = this.input.value.trim();

        this.abortController?.abort();

        if (query.length < 2) {
          this.closeResults();
          return;
        }

        this.abortController = new AbortController();
        this.renderStatus('Suche läuft…');

        fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`, {
          signal: this.abortController.signal,
          headers: { Accept: 'application/json' }
        })
          .then((response) => response.ok ? response.json() : Promise.reject(response))
          .then((data) => this.renderResults(query, data.resources?.results?.products || []))
          .catch((error) => {
            if (error.name !== 'AbortError') this.closeResults();
          });
      }

      renderResults(query, products) {
        if (!products.length) {
          this.renderStatus(`Keine Treffer für „${query}".`);
          return;
        }

        const rows = products.map((product, index) => this.renderProduct(product, index)).join('');
        const searchUrl = `${this.form.getAttribute('action')}?q=${encodeURIComponent(query)}&type=product`;

        this.results.innerHTML = `${rows}
          <a id="HeaderSearchOption-${products.length}" class="site-header__search-option site-header__search-all" role="option" href="${searchUrl}">
            <span class="site-header__search-title">Alle Ergebnisse für „${this.escapeHtml(query)}" anzeigen</span>
          </a>`;
        this.openResults();
      }

      renderProduct(product, index) {
        const image = this.imageUrl(product.image || product.featured_image?.url || '');
        const price = this.formattedPrice(product.price);

        return `<a id="HeaderSearchOption-${index}" class="site-header__search-option" role="option" href="${product.url || '#'}">
          ${image ? `<img class="site-header__search-thumb" src="${image}" alt="" loading="lazy">` : ''}
          <span class="site-header__search-title">
            ${this.escapeHtml(product.title || '')}
            ${price ? `<span class="site-header__search-price">${this.escapeHtml(price)}</span>` : ''}
          </span>
        </a>`;
      }

      renderStatus(message) {
        this.results.innerHTML = `<div class="site-header__search-status" role="option" aria-disabled="true">${this.escapeHtml(message)}</div>`;
        this.openResults();
      }

      openResults() {
        this.results.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
        this.activeIndex = -1;
        this.input.removeAttribute('aria-activedescendant');
      }

      closeResults() {
        this.results.hidden = true;
        this.input.setAttribute('aria-expanded', 'false');
        this.activeIndex = -1;
        this.input.removeAttribute('aria-activedescendant');
        this.options().forEach((option) => {
          option.classList.remove('is-active');
          option.removeAttribute('aria-selected');
        });
      }

      toggleMobileSearch() {
        const isOpen = this.classList.toggle('is-open');
        this.toggle.setAttribute('aria-expanded', String(isOpen));

        if (isOpen) {
          this.input.focus();
        } else {
          this.closeResults();
        }
      }

      closeOnOutside(event) {
        if (this.contains(event.target)) return;
        this.closeResults();
        this.classList.remove('is-open');
        this.toggle?.setAttribute('aria-expanded', 'false');
      }

      onKeydown(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.closeResults();
          this.input.focus();
          return;
        }

        if (event.key === 'Enter' && this.activeIndex > -1) {
          event.preventDefault();
          this.options()[this.activeIndex]?.click();
          return;
        }

        if (!['ArrowDown', 'ArrowUp'].includes(event.key)) return;

        const options = this.options();
        if (!options.length || this.results.hidden) return;

        event.preventDefault();
        this.activeIndex = event.key === 'ArrowDown'
          ? (this.activeIndex + 1) % options.length
          : (this.activeIndex - 1 + options.length) % options.length;

        options.forEach((option, index) => {
          const isActive = index === this.activeIndex;
          option.classList.toggle('is-active', isActive);
          option.setAttribute('aria-selected', String(isActive));
        });

        this.input.setAttribute('aria-activedescendant', options[this.activeIndex].id);
        options[this.activeIndex].scrollIntoView({ block: 'nearest' });
      }

      options() {
        return Array.from(this.results.querySelectorAll('a[role="option"]'));
      }

      imageUrl(src) {
        if (!src) return '';

        try {
          const url = new URL(src, window.location.origin);
          url.searchParams.set('width', '96');
          return url.toString();
        } catch (error) {
          return '';
        }
      }

      formattedPrice(price) {
        return typeof price === 'string' && /[^\d.,\s]/.test(price) ? price : '';
      }

      escapeHtml(value) {
        return value.replace(/[&<>"']/g, (character) => ({
          '&': '&amp;',
          '<': '&lt;',
          '>': '&gt;',
          '"': '&quot;',
          "'": '&#39;'
        })[character]);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const loadRecommendations = async (section) => {
      if (section.dataset.recommendationsLoaded === 'true') return;

      section.dataset.recommendationsLoaded = 'true';

      try {
        const response = await fetch(section.dataset.url);
        if (!response.ok) return;

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const replacement = doc.querySelector('[data-related-products]');

        if (!replacement) {
          if (section.hidden) section.remove();
          return;
        }

        replacement.querySelectorAll('[data-focus-reveal]').forEach((element) => {
          element.classList.add('is-visible');
        });

        section.replaceWith(replacement);
      } catch (error) {
        if (section.hidden) section.remove();
      }
    };

    document.querySelectorAll('[data-related-products][data-url]').forEach((section) => {
      if (section.hidden || !('IntersectionObserver' in window)) {
        loadRecommendations(section);
        return;
      }

      const observer = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        observer.disconnect();
        loadRecommendations(section);
      }, { rootMargin: '300px 0px' });

      observer.observe(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
